<template>
  <b-row>
    <b-col cols="6">
      <div class="surveyCalculatorAddStrata" @click="removeStrata()">x</div>
      <div>
        <b-form-input
          v-model="strata.name"
          :placeholder="
            $t('label_opinionSurvey_calculator_stratifiedSample_name')
          "
          class="surveyCalculatorField"
          style="text-align: left"
        />
      </div>
    </b-col>
    <b-col cols="6">
      <b-row>
        <b-col cols="4" style="text-align: center; padding-top: 10px">
          {{ $t("label_opinionSurvey_calculator_women") }}
        </b-col>
        <b-col cols="4">
          <form-input-numeric
            v-model="strata.women"
            class="surveyCalculatorField"
            min="0"
            @input="calculateStrata"
          />
        </b-col>
        <b-col cols="4">
          <form-input-numeric
            v-model="strata.strataWomen"
            class="surveyCalculatorField surveyCalculatorField-blue surveyCalculatorField-bold"
            min="0"
            disabled
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" style="text-align: center; padding-top: 10px">
          {{ $t("label_opinionSurvey_calculator_men") }}
        </b-col>
        <b-col cols="4">
          <form-input-numeric
            v-model="strata.men"
            class="surveyCalculatorField"
            min="0"
            @input="calculateStrata"
          />
        </b-col>
        <b-col cols="4">
          <form-input-numeric
            v-model="strata.strataMen"
            class="surveyCalculatorField surveyCalculatorField-blue surveyCalculatorField-bold"
            min="0"
            disabled
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { calculateStrata } from "../../utils/commons";

export default {
  name: "TemplateOpinionSurveyStrata",
  props: {
    strata: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
    },
  },
  data: function () {
    return {};
  },
  watch: {
    "strata.name": function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.calculateStrata();
      }, 500);
    },
  },
  created() {},
  methods: {
    calculateStrata: function () {
      this.strata.index = this.index;
      this.strata.strataMen = calculateStrata(this.strata.men);
      this.strata.strataWomen = calculateStrata(this.strata.women);
      this.$emit("update", { strata: this.strata, index: this.index });
    },
    removeStrata: function () {
      this.$emit("delete", this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.surveyCalculator {
  &AddStrata {
    background: #03a19c;
    border-radius: 6px;
    font-size: 15px;
    font-weight: bold;
    color: #ffffff;
    width: 20px;
    height: 20px;
    line-height: 18px;
    cursor: pointer;
    text-align: center;
    position: absolute;
    top: 12px;
    left: -19px;

    &Text {
      width: 250px;
      cursor: pointer;
      display: inline-block;
    }
  }
}

.surveyCalculatorField {
  margin: 4px;
  text-align: center;

  &-blue {
    border-color: #03a19c;
    border-width: 2px;
  }

  &-bold {
    border-width: 2px;
    font-weight: bold;
  }
}

@media (max-width: 990px) {
  .surveyCalculatorAddStrata {
    position: absolute;
    top: 12px;
    left: -10px;
  }
}
</style>
